module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-9-93c25dc0ffd2a522330d342fd81cfdde.webp";